module.exports = __webpack_public_path__ + "static/media/icon_fleetstatus.16a40df5.svg";